import React, { useEffect, useState, useRef } from "react";
import {
  getCurrentUser,
  getCompanyData,
  getAllClientsData,
} from "../apis"; // Corrected import path
import { createStripedPattern } from "../clientInterface/chartUtils";
import { transformDataToTree, transformObjectToTree } from "../clientInterface/dataTransformers";
import { 
  renderGlobalIndexChart, 
  renderCitiesChart, 
  renderCallCenterMediaPesataChart,
  renderSitoMediaPesataChart,
  renderAppMediaPesataChart,
  renderCategoryDetailsChart,
  renderNestedDataChart,
  renderCityDetailsChart
} from "../clientInterface/chartRenderers";
import {
  Legend,
  LegendComparable,
  RenderIcons,
  TourButton,
  WelcomeCard,
  CompanyDataPanel,
  MainChartCard,
  ChartInfoPanel
} from "../clientInterface/uiComponents";
import {
  message,
  Card,
  Tree,
  Typography,
  Spin,
  Row,
  Col,
  Divider,
  Space,
  Button,
  Collapse,
  Tour, // <-- Add Tour import
  Dropdown,
  Tag,
} from "antd";
import {
  UserOutlined,
  ApartmentOutlined,
  GlobalOutlined,
  LoadingOutlined,
  FolderOpenOutlined,
  FileOutlined,
  InfoCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import * as echarts from "echarts";
import { GiBus } from "react-icons/gi";
import { TbBusStop } from "react-icons/tb";
import { IoBusinessSharp } from "react-icons/io5";
import { FaMobileAlt } from "react-icons/fa";
import { MdComputer } from "react-icons/md";
import { FcAssistant } from "react-icons/fc";
import { HiOutlineTicket } from "react-icons/hi2";
import { GiBusStop } from "react-icons/gi";
import { FaPhoneAlt } from "react-icons/fa";
import useECharts from "../hooks/useECharts";
import { fetchVersions } from "../apis";
const { Title, Text } = Typography;
const { DirectoryTree } = Tree;
const { Panel } = Collapse;

function ClientInterface() {
  const [userData, setUserData] = useState(null);
  const [treeData, setTreeData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allClientsData, setAllClientsData] = useState([]);
  const [chartLevel, setChartLevel] = useState(0); // 0: Global Index, 1: Cities, 2: City Details, 3: App Details, 4: Sito Details, 5: Call Center Details
  const [chartHistory, setChartHistory] = useState([]); // Navigation history
  const [selectedClient, setSelectedClient] = useState(null);
  const [showChart, setShowChart] = useState(true);
  const [versions, setVersions] = useState([]);
  const [currentVersion, setCurrentVersion] = useState(null);

  const chartRef = useRef(null); // Ref for Global Index chart and all drill-down charts
  const appChartRef = useRef(null); // Ref for App overview chart
  const sitoChartRef = useRef(null); // Ref for Sito overview chart
  const callCenterChartRef = useRef(null); // Ref for Call Center overview chart

  // Use the custom hook for ECharts instance management
  const chartInstance = useECharts(chartRef, [
    chartLevel,
    allClientsData,
    userData,
    chartHistory,
  ]);
  const appChartInstance = useECharts(appChartRef, [
    chartLevel,
    allClientsData,
    userData,
    chartHistory,
  ]);
  const sitoChartInstance = useECharts(sitoChartRef, [
    chartLevel,
    allClientsData,
    userData,
    chartHistory,
  ]);
  const callCenterChartInstance = useECharts(callCenterChartRef, [
    chartLevel,
    allClientsData,
    userData,
    chartHistory,
  ]);

  // Tour refs
  const treePanelRef = useRef(null); // For the panel containing the DirectoryTree
  const treeRef = useRef(null); // For the DirectoryTree itself
  const mainChartRef = useRef(null); // For the main chart
  const appChartCardRef = useRef(null); // For App chart card
  const sitoChartCardRef = useRef(null); // For Sito chart card
  const callCenterChartCardRef = useRef(null); // For Call Center chart card

  // Tour state
  const [tourOpen, setTourOpen] = useState(false);

  useEffect(() => {
    const originalRemoveChild = Node.prototype.removeChild;

    Node.prototype.removeChild = function (child) {
      if (!this.contains(child)) {
        console.warn("🛑 Prevented removeChild on non-child node:", child);
        return child;
      }
      return originalRemoveChild.call(this, child);
    };

    // Optional: cleanup on unmount
    return () => {
      Node.prototype.removeChild = originalRemoveChild;
    };
  }, []);

  useEffect(() => {
    if (selectedClient && userData?.is_admin) {
      setUserData({ ...userData, company: selectedClient });
    }
  }, [selectedClient]);

  // Tour steps
  const steps = [
    {
      title: "Elenco dei dati della tua azienda",
      description:
        "Qui puoi vedere la struttura di categorie e sottocategorie che compongono l'indagine. Fai click per esplorare i punteggi di ciascuna",
      target: () => treePanelRef.current,
    },
    {
      title: "Grafico principale",
      description:
        "Fai click su una barra arancione per esplorare le sottocategorie.",
      target: () => mainChartRef.current,
    },
  ];

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const token = localStorage.getItem('authToken');
  //       if (!token) {
  //         throw new Error('Token di autenticazione non trovato');
  //       }

  //       const user = await getCurrentUser(token);
  //       setUserData(user);

  //       if (user?.company) {
  //         const data = await getCompanyData(user.company);
  //         const transformed = transformDataToTree(data);
  //         setTreeData(transformed);
  //       }

  //       const allClients = await getAllClientsData();

  //       if (allClients) {
  //         setAllClientsData(allClients);
  //         setSelectedClient(Object.keys(allClients)[0]);
  //       } else {
  //         setAllClientsData({});
  //       }

  //     } catch (error) {
  //       console.error('Errore:', error);
  //       message.error('Caricamento dati fallito');
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
    var fetchData = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        throw new Error("Token di autenticazione non trovato");
      }

      const user = await getCurrentUser(token);
      setUserData(user);
      var response = await fetchVersions();
      if (response.status !== 200) {
        console.error("Error fetching versions:", response.statusText);
        setLoading(false);
      } else {
        var versions_data = response?.data.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        var currentData = versions_data[0]?.json_data;
        setCurrentVersion(versions_data[0]?.version);
        setSelectedClient(Object.keys(currentData)[0]);
        setVersions(versions_data);
        setAllClientsData(currentData || {});
        const transformed = transformDataToTree(currentData[user?.company]);
        setTreeData(transformed || []);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!loading && userData?.company) {
      var version_data = versions.find((v) => v.version === currentVersion);
      var currentData = version_data?.json_data;
      setAllClientsData(currentData || {});
      const transformed = transformDataToTree(currentData[userData?.company]);
      setTreeData(transformed || []);
    }
  }, [currentVersion]);

  useEffect(() => {
    if (loading || !Object.keys(allClientsData).length || !userData) return;

    renderChart();

    const handleResize = () => {
      chartInstance.current?.resize();
      appChartInstance.current?.resize();
      sitoChartInstance.current?.resize();
      callCenterChartInstance.current?.resize();
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [
    loading,
    allClientsData,
    userData,
    chartLevel,
    chartHistory,
    chartInstance,
    appChartInstance,
    sitoChartInstance,
    callCenterChartInstance,
  ]);

  const renderChart = () => {
    const chart = chartInstance.current;
    if (!chart) return;

    switch (chartLevel) {
      case 0:
        renderGlobalIndexChartWrapper();
        break;
      case 1:
        renderCitiesChartWrapper();
        renderAppMediaPesataChartWrapper();
        renderSitoMediaPesataChartWrapper();
        renderCallCenterMediaPesataChartWrapper();
        break;
      case 2:
        renderCityDetailsChartWrapper(); // This case is now modified to show specific MEDIA PESATA values
        break;
      case 3: // App Details
        renderCategoryDetailsChart(chartInstance, "App", [
          "CONTENUTI",
          "USER EXPERIENCE",
          "FUNZIONALITA",
          "MEDIA PESATA",
        ], userData, allClientsData);
        break;
      case 4: // Sito Details
        renderCategoryDetailsChart(chartInstance, "Sito", [
          "CONTENUTI",
          "CHIAREZZA INFO",
          "FUNZIONI",
          "SERVIZI",
          "MEDIA PESATA",
        ], userData, allClientsData);
        break;
      case 5: // Call Center Details
        renderCategoryDetailsChart(chartInstance, "Call Center", [
          "ATTESA",
          "PERSONALE",
          "MESSAGGERIA",
          "MEDIA PESATA",
        ], userData, allClientsData);
        break;
      case 6: // Nested data drill-down
        renderNestedDataChartWrapper();
        break;
      default:
        // Fallback for unexpected chartLevel
        chart.setOption({
          title: { text: "Nessun dato disponibile", left: "center" },
          series: [{ type: "bar", data: [] }],
        });
    }
  };


  // Simplified - now uses extracted function
  const renderGlobalIndexChartWrapper = () => {
    renderGlobalIndexChart(chartInstance, userData, allClientsData, handleChartLevelChange, setChartHistory);
  };

  // Simplified - now uses extracted function
  const renderCitiesChartWrapper = () => {
    renderCitiesChart(chartInstance, userData, allClientsData, handleChartLevelChange, setChartHistory);
  };

  // Simplified - now uses extracted function
  const renderCityDetailsChartWrapper = () => {
    renderCityDetailsChart(chartInstance, userData, allClientsData, chartHistory, handleChartLevelChange, setChartHistory);
  };

  // Simplified - now uses extracted function
  const renderNestedDataChartWrapper = () => {
    renderNestedDataChart(chartInstance, userData, allClientsData, chartHistory);
  };


  // Simplified - now uses extracted function
  const renderAppMediaPesataChartWrapper = () => {
    renderAppMediaPesataChart(appChartInstance, userData, allClientsData, handleChartLevelChange, setChartHistory);
  };

  // Simplified - now uses extracted function
  const renderSitoMediaPesataChartWrapper = () => {
    renderSitoMediaPesataChart(sitoChartInstance, userData, allClientsData, handleChartLevelChange, setChartHistory);
  };

  // Simplified - now uses extracted function
  const renderCallCenterMediaPesataChartWrapper = () => {
    renderCallCenterMediaPesataChart(callCenterChartInstance, userData, allClientsData, handleChartLevelChange, setChartHistory);
  };

  const goBack = () => {
    if (chartHistory.length > 0) {
      const newHistory = [...chartHistory];
      const prevState = newHistory.pop();
      setChartHistory(newHistory);
      handleChartLevelChange(prevState ? prevState.level : 0);
    }
  };

  const resetToRoot = () => {
    handleChartLevelChange(0);
    setChartHistory([]);
  };


  const getCurrentChartTitle = () => {
    if (chartLevel === 1) {
      return chartHistory.length > 0
        ? chartHistory[chartHistory.length - 1].title
        : "Punteggio globale per territorio servito";
    }

    if (chartLevel === 3) return "Punteggio categorie app";
    if (chartLevel === 4) return "Punteggio globale sito web";
    if (chartLevel === 5) return "Punteggio globale call center";

    // Fallback for unexpected chartLevel
    if (chartHistory.length > 0) {
      return chartHistory[chartHistory.length - 1].title;
    }
    return ""; // Default fallback
  };

  // Define the handler for controlled chart level changes
  const handleChartLevelChange = (newLevel) => {
    setShowChart(false);
    setTimeout(() => {
      setChartLevel(newLevel);
      setShowChart(true);
    }, 100);
  };

  if (loading) {
    return (
      <div className="client-interface-loading">
        <Spin
          indicator={
            <LoadingOutlined className="client-interface-loading-spinner" spin />
          }
        />
      </div>
    );
  }


  return (
    <div className="client-interface-container">
      {/* Tour trigger button */}
      <TourButton setTourOpen={setTourOpen} />
      <WelcomeCard 
        userData={userData}
        allClientsData={allClientsData}
        selectedClient={selectedClient}
        setSelectedClient={setSelectedClient}
        versions={versions}
        currentVersion={currentVersion}
        setCurrentVersion={setCurrentVersion}
      />

      <CompanyDataPanel 
        treePanelRef={treePanelRef}
        treeRef={treeRef}
        treeData={treeData}
        userData={userData}
      />

      <Divider />

      {/* Main Chart Section - always visible */}
      <Card
        title={
          <span className="client-interface-chart-title">
            <RenderIcons chartLevel={chartLevel} chartHistory={chartHistory} />
            {getCurrentChartTitle()}
          </span>
        }
        bordered
        className="client-interface-main-chart-card"
        extra={
          <Space>
            {chartLevel > 0 && (
              <Button icon={<ArrowLeftOutlined />} onClick={goBack}>
                Indietro
              </Button>
            )}
            {chartLevel > 0 && (
              <Button onClick={resetToRoot}>Torna all'inizio</Button>
            )}
          </Space>
        }
      >
        {/* Always render the chart container, even if no data, to avoid DOM removal issues */}
        <div ref={mainChartRef}>
          {showChart && (
            <div
              ref={chartRef}
              key={`main-chart-${chartLevel}`}
              className="client-interface-chart"
            />
          )}
          {/* Show legend and info if data exists, otherwise show a placeholder */}
          {Object.keys(allClientsData).length ? (
            <>
              {chartLevel >= 3 && chartLevel <= 5 ? (
                <LegendComparable />
              ) : (
                <Legend />
              )}
              <ChartInfoPanel chartLevel={chartLevel} chartHistory={chartHistory} userData={userData} />
            </>
          ) : (
            <Text>Nessun dato disponibile per il confronto</Text>
          )}
        </div>
      </Card>

      {/* New Charts for App, Sito, Call Center - only visible at chartLevel 0 */}
      {chartLevel === 1 && Object.keys(allClientsData).length > 0 ? (
        <>
          <div ref={appChartCardRef}>
            <Card
              title={
                <FaMobileAlt className="client-interface-section-icon" />
              }
              bordered
              className="client-interface-section-card"
            >
              <div ref={appChartRef} className="client-interface-section-chart" />
              <LegendComparable />
              <div className="client-interface-section-info">
                <Text type="secondary">
                  Questo grafico mostra la "Media Pesata" per la sezione "App"
                  di tutti i clienti. Clicca sulla barra della tua azienda per
                  vedere i dettagli.
                </Text>
              </div>
            </Card>
          </div>

          <div ref={sitoChartCardRef}>
            <Card
              title={
                <span>
                  <MdComputer className="client-interface-section-icon" />
                </span>
              }
              bordered
              className="client-interface-section-card"
            >
              <div ref={sitoChartRef} className="client-interface-section-chart" />
              <LegendComparable />
              <div className="client-interface-section-info">
                <Text type="secondary">
                  Questo grafico mostra la "Media Pesata" per la sezione "Sito"
                  di tutti i clienti. Clicca sulla barra della tua azienda per
                  vedere i dettagli.
                </Text>
              </div>
            </Card>
          </div>

          <div ref={callCenterChartCardRef}>
            <Card
              title={
                <span>
                  <FaPhoneAlt className="client-interface-section-icon client-interface-section-icon--small" />
                </span>
              }
              bordered
              className="client-interface-section-card"
            >
              <div
                ref={callCenterChartRef}
                className="client-interface-section-chart"
              />
              <LegendComparable />
              <div className="client-interface-section-info">
                <Text type="secondary">
                  Questo grafico mostra la "Media Pesata" per la sezione "Call
                  Center" di tutti i clienti. Clicca sulla barra della tua
                  azienda per vedere i dettagli.
                </Text>
              </div>
            </Card>
          </div>
        </>
      ) : (
        ""
      )}

      {/* Ant Design Tour */}
      <Tour open={tourOpen} onClose={() => setTourOpen(false)} steps={steps} />
    </div>
  );
}

export default ClientInterface;
